export default __webpack_public_path__ + "b2dd6a368b47f76c7d3a07fd824f15c2.svg";